export const SCALER_PREFIX = 'scaler';
export const RESIZE_SCALER_PREFIX = 'resize';

// Images from source - Autotrader.
export const IMAGE_SERVERS = ['images.autotrader.com', 'atcimages.kbb.com', 'img.fordblueadvantage.com', 'images.fordblueadvantage.com', 'external-images-sdc.autotrader.com', 'external-images-cp.autotrader.com', 'external-images-dd.autotrader.com', 'images2.autotrader.com', 'images.qa.autotrader.com', 'images-preprod.autotrader.com', 'images-test.fordblueadvantage.com', 'listing-images-np.caranddriver.com', 'listing-images.caranddriver.com'];

// Images from source - Cox Auto Media Management.
export const ASSET_IMAGE_SERVERS = ['assets.cai-media-management-np.com', 'assets.cai-media-management.com'];
const sizePattern = '[0-9]+';
const resizePattern = '\\d+x\\d+';
export const joinPath = function () {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return args.join('/');
};
function parseSource(src) {
  // Node URL does not support protocol-relative URLs, so default to https
  const protocol = src.startsWith('//') ? 'https:' : '';
  return new URL(protocol + src);
}

// If an image is hosted by an ATC image server (so that we know we may add the scaler string) and has non-zero area
function isImageScalable(_ref) {
  let {
    src,
    height,
    width
  } = _ref;
  try {
    const {
      hostname
    } = parseSource(src);
    return [...IMAGE_SERVERS, ...ASSET_IMAGE_SERVERS].includes(hostname) && Number.parseInt(width, 10) > 0 && Number.parseInt(height, 10) > 0;
  } catch (err) {
    return false;
  }
}
export default function getScaledImageSource(options) {
  const {
    src,
    height,
    width,
    isOptimized = false
  } = options;

  // return original src if image is not defined or not scalable
  if (!isImageScalable(options)) {
    return src;
  }
  const parsedSrc = parseSource(src);
  let correctScaler = joinPath(SCALER_PREFIX, String(width), String(height));
  let pattern = new RegExp(`^/${joinPath(SCALER_PREFIX, sizePattern, sizePattern)}`);
  if (ASSET_IMAGE_SERVERS.includes(parsedSrc.hostname) || parsedSrc.pathname.includes(RESIZE_SCALER_PREFIX)) {
    correctScaler = joinPath(RESIZE_SCALER_PREFIX, String(width) + 'x' + String(height));
    pattern = new RegExp(`^/${joinPath(RESIZE_SCALER_PREFIX, resizePattern)}`);
  }

  // Remove any existing scaler
  parsedSrc.pathname = parsedSrc.pathname.replace(pattern, '');
  if (ASSET_IMAGE_SERVERS.includes(parsedSrc.hostname)) {
    parsedSrc.hostname = parsedSrc.hostname.replace(ASSET_IMAGE_SERVERS[0], 'images.qa.autotrader.com').replace(ASSET_IMAGE_SERVERS[1], 'images.autotrader.com');
    parsedSrc.host = parsedSrc.host.replace(ASSET_IMAGE_SERVERS[0], 'images.qa.autotrader.com').replace(ASSET_IMAGE_SERVERS[1], 'images.autotrader.com');
  }
  if (isOptimized) {
    parsedSrc.searchParams.append('format', 'auto');
    parsedSrc.searchParams.append('width', width);
    if (height) {
      parsedSrc.searchParams.append('height', height);
    }
    return parsedSrc.href;
  }

  // Prepend the correct scaler string after removing previous occurrence of the pattern'
  parsedSrc.pathname = correctScaler + parsedSrc.pathname;
  return parsedSrc.href;
}